// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportTable.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function() {
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var action = require('./Izenda.ReportTableAction');
  var Table = require('share/components/controls/DataGrid/Izenda.Table').Table;
  var Column = require('share/components/controls/DataGrid/Izenda.Table').Column;
  var constants = require('logic/data/Izenda.ReportPartSelectionConstants');
  var Paginator = require('share/components/controls/DataGrid/helpers/Izenda.Paginator');

  var TABLE_DEF_REPORT = constants.TABLE_DEF_REPORT;
  const { map } = require('lodash/fp');
  var ReportTable = React.createClass({
    renderReportData: function(dataRow, key) {
      return (
        <div className="overflow-text" title={dataRow[key]}>
          {dataRow[key]}
        </div>
      );
    },
    renderSaveInto: function(dataRow, key) {
      var reportPartSelectionStore = this.props.reportPartSelectionStore;
      var saveIntoText = dataRow[key]
        ? reportPartSelectionStore.globalReportName
        : reportPartSelectionStore.localReportName;
      return (
        <div className="overflow-text" title={dataRow[key]}>
          {saveIntoText}
        </div>
      );
    },
    renderRadioButton: function(dataRow) {
      var selectedReport = this.props.reportPartSelection.selectedReport;

      return (
        <input
          type="radio"
          className="izenda-ReportPartSelectionPopup-ReportPartGrid-radioBtn"
          checked={dataRow === selectedReport}
        />
      );
    },
    render: function() {
      var props = this.props;
      var reportPartSelection = props.reportPartSelection;
      var reportPartSelectionStore = props.reportPartSelectionStore;
      var pageInfo = reportPartSelection.pageInfo;

      return (
        <section>
          <Table
            dataSource={reportPartSelection.reportCollection}
            sortInfo={pageInfo.colSortDirs}
            onSortChange={props.onSortChange}
            onClickRow={reportPartSelection.setSelectedReport.bind(reportPartSelection)}
            minHeight={constants.TABLE_REPORT.height}
            maxHeight={constants.TABLE_REPORT.height}
          >
            {map(
              function(columnDef) {
                return <Column {...columnDef} cell={this[columnDef.renderMethod]} />;
              }.bind(this),
              TABLE_DEF_REPORT
            )}
          </Table>
          <Paginator onChange={props.onPageChange} onDropdownChange={props.onPageSizeChange} pageInfo={pageInfo} />
        </section>
      );
    }
  });

  module.exports = connect(action)(ReportTable);
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/ReportPartSelectionPopup/Izenda.ReportTable.jsx